export default {"src":"/_next/static/media/disabled.2ccf328d.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};